import { firebaseApp } from './../firebase';
import { getFirestore, collection, getDocs, query, where } from "firebase/firestore";

// Action types
export const LOAD_BOT_ACTIVITY_BY_HANDLE_START = 'LOAD_BOT_ACTIVITY_BY_HANDLE_START';
export const LOAD_BOT_ACTIVITY_BY_HANDLE_SUCCESS = 'LOAD_BOT_ACTIVITY_BY_HANDLE_SUCCESS';
export const LOAD_BOT_ACTIVITY_BY_HANDLE_ERROR = 'LOAD_BOT_ACTIVITY_BY_HANDLE_ERROR';

// Load bot activity by handle actions
export const loadBotActivityByHandleStart = () => {
    return { type: LOAD_BOT_ACTIVITY_BY_HANDLE_START };
};

export const loadBotActivityByHandleSuccess = (botActivity) => {
    return { type: LOAD_BOT_ACTIVITY_BY_HANDLE_SUCCESS, payload: botActivity };
};

export const loadBotActivityByHandleError = (errorMessage) => {
    return { type: LOAD_BOT_ACTIVITY_BY_HANDLE_ERROR, payload: errorMessage };
};

export const loadBotActivityByHandle = (userId, handle) => {
    return async(dispatch) => {
        dispatch(loadBotActivityByHandleStart());

        if (!userId || !handle) {
            dispatch(loadBotActivityByHandleSuccess([]));
            return;
        }

        try {
            const firestore = getFirestore(firebaseApp);
            const botActivityQuerySnapshot = await getDocs(query(
                collection(firestore, "botExecutionLogs"),
                where("userId", "==", userId),
                where("handle", "==", handle)
            ));
            const botActivity = botActivityQuerySnapshot.docs.map((doc) => doc.data());

            dispatch(loadBotActivityByHandleSuccess(botActivity));
        } catch (error) {
            dispatch(loadBotActivityByHandleError(error.message));
        }
    };
};